import { render } from "./TxDetail.vue?vue&type=template&id=0dc5d14a"
import script from "./TxDetail.vue?vue&type=script&lang=js"
export * from "./TxDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__